export const courses = [
  {
    originalName: "futureengineers",
    displayName: "Future Engineers Programme",
    imageUrl: "/images/futureengineers.webp",
    categories: ["Future Engineers"],
  },
  {
    originalName: "comptiaa+.html",
    displayName: "COMPTIA A+",
    imageUrl: "/images/logoaplus.svg",
    categories: [ "CompTIA"],
  },
  {
    originalName: "comptiacourses.html",
    displayName: "COMPTIA CORE",
    imageUrl: "/images/comptiacore.webp",
    categories: ["IT Certification", "CompTIA"],
  },
  {
    originalName: "cmptian+.html",
    displayName: "COMPTIA N+",
    imageUrl: "/images/logonetworkplus.svg",
    categories: ["CompTIA"],
  },
  {
    originalName: "comptiacybersec.html",
    displayName: "COMPTIA CYBERSECURITY",
    imageUrl: "/images/logocysaplus-01.svg",
    categories: ["CompTIA" , 'CYBERSECURITY'],
  },
  {
    originalName: "comptiafundamentals.html",
    displayName: "COMPTIA FUNDAMENTALS",
    imageUrl: "/images/logoitfundamentals.svg",
    categories: ["CompTIA"],
  },
  {
    originalName: "comptiainfrastructure.html",
    displayName: "COMPTIA INFRASTRUCTURE",
    imageUrl: "/images/comptiacore.webp",
    categories: ["CompTIA"],
  },
  {
    originalName: "ibmdatapower.html",
    displayName: "IBM DATAPOWER",
    imageUrl: "/images/ibm.webp",
    categories: ["IBM"],
  },
  {
    originalName: "ibmdb2c.html",
    displayName: "IBM DB2C",
    imageUrl: "/images/ibm.webp",
    categories: ["IBM"],
  },
  {
    originalName: "ibmendp.html",
    displayName: "IBM ENDPOINT",
    imageUrl: "/images/ibm.webp",
    categories: ["IBM"],
  },
  {
    originalName: "ibmguardium.html",
    displayName: "IBM GUARDIUM",
    imageUrl: "/images/ibm.webp",
    categories: ["IBM"],
  },
  {
    originalName: "ibmi.html",
    displayName: "IBM I",
    imageUrl: "/images/ibm.webp",
    categories: ["IBM"],
  },
  {
    originalName: "ibmitcam.html",
    displayName: "IBM ITCAM",
    imageUrl: "/images/ibm.webp",
    categories: ["IBM"],
  },
  {
    originalName: "ibmblockchain.html",
    displayName: "IBM BLOCKCHAIN",
    imageUrl: "/images/ibm.webp",
    categories: ["IBM"],
  },
  {
    originalName: "ibmpowersystem.html",
    displayName: "IBM POWER SYSTEM",
    imageUrl: "/images/ibm.webp",
    categories: ["IBM"],
  },
  {
    originalName: "ibmsystemx.html",
    displayName: "IBM SYSTEM X",
    imageUrl: "/images/ibm.webp",
    categories: ["IBM"],
  },
  {
    originalName: "ibmsystemstore.html",
    displayName: "IBM SYSTEM STORE",
    imageUrl: "/images/ibm.webp",
    categories: ["IBM"],
  },
  {
    originalName: "ibmtrivovistore.html",
    displayName: "IBM TIVOLI STORE",
    imageUrl: "/images/ibm.webp",
    categories: ["IBM"],
  },
  {
    originalName: "ibmwebsphereappserver.html",
    displayName: "IBM WEBSPHERE APP SERVER",
    imageUrl: "/images/ibm.webp",
    categories: ["IBM"],
  },
  {
    originalName: "ibmwebspheremb.html",
    displayName: "IBM WEBSPHERE MB",
    imageUrl: "/images/ibm.webp",
    categories: ["IBM"],
  },
  {
    originalName: "ibmwebspheremq.html",
    displayName: "IBM WEBSPHERE MQ",
    imageUrl: "/images/ibm.webp",
    categories: ["IBM"],
  },
  {
    originalName: "itil.html",
    displayName: "ITIL COURSES",
    imageUrl: "/images/itil.webp",
    categories: ["ITIL"],
  },
  {
    originalName: "popia.html",
    displayName: "POPIA COURSES",
    imageUrl: "/images/popia.webp",
    categories: ["POPIA", "Legal Compliance"],
  },
  {
    originalName: "programdev.html",
    displayName: "PROGRAM DEVELOPMENT COURSES",
    imageUrl: "/images/pecb3.webp",
    categories: ["Programming"],
  },
  {
    originalName: "certnexus.html",
    displayName: "CERTNEXUS COURSES",
    imageUrl: "/images/certnexus.webp",
    categories: ["Certnexus"],
  },
  {
    originalName: "certnexusai.html",
    displayName: "CERTNEXUS AI",
    imageUrl: "/images/certnexus.webp",
    categories: ["Certnexus"],
  },
  {
    originalName: "certnexuscybersec.html",
    displayName: "CERTNEXUS CYBERSECURITY",
    imageUrl: "/images/certnexus.webp",
    categories: ["Certnexus"],
  },
  {
    originalName: "certnexusdatascience.html",
    displayName: "CERTNEXUS DATA SCIENCE",
    imageUrl: "/images/certnexus.webp",
    categories: ["Certnexus"],
  },
  {
    originalName: "certnexusiot.html",
    displayName: "CERTNEXUS IOT",
    imageUrl: "/images/certnexus.webp",
    categories: ["Certnexus"],
  },
  {
    originalName: "microsoft365.html",
    displayName: "MICROSOFT 365",
    imageUrl: "/images/Microsoft-365.webp",
    categories: ["Microsoft"],
  },
  {
    originalName: "microsoftadmin.html",
    displayName: "MICROSOFT ADMIN",
    imageUrl: "/images/admin.webp",
    categories: ["Microsoft"],
  },
  {
    originalName: "microsoftaiengineer.html",
    displayName: "AI ENGINEER",
    imageUrl: "/images/microsoft.webp",
    categories: ["Microsoft"],
  },
  {
    originalName: "microsoftazurefundamentals.html",
    displayName: "AZURE FUNDAMENTALS",
    imageUrl: "/images/azure.webp",
    categories: ["Microsoft"],
  },
  {
    originalName: "microsoftCOURSES.html",
    displayName: "MICROSOFT COURSES",
    imageUrl: "/images/microsoft.webp",
    categories: ["Microsoft"],
  },
  {
    originalName: "microsoftdataandai.html",
    displayName: "DATA & AI",
    imageUrl: "/images/microsoft.webp",
    categories: ["Microsoft"],
  },
  {
    originalName: "microsoftDATAANAASS.html",
    displayName: "DATA ANALYTICS & ASSOCIATE",
    imageUrl: "/images/microsoft.webp",
    categories: ["Microsoft"],
  },
  {
    originalName: "microsoftdatabaseadmin.html",
    displayName: "DATABASE ADMINISTRATION",
    imageUrl: "/images/microsoft.webp",
    categories: ["Microsoft"],
  },
  {
    originalName: "microsoftDATAENGINEER.html",
    displayName: "DATA ENGINEER",
    imageUrl: "/images/microsoft.webp",
    categories: ["Microsoft"],
  },
  {
    originalName: "microsoftdesktop.html",
    displayName: "MICROSOFT DESKTOP",
    imageUrl: "/images/microsoft.webp",
    categories: ["Microsoft"],
  },
  {
    originalName: "microsoftdevop.html",
    displayName: "MICROSOFT DEVOPS",
    imageUrl: "/images/microsoft.webp",
    categories: ["Microsoft"],
  },
  {
    originalName: "microsoftiotdev.html",
    displayName: "IOT DEVELOPMENT",
    imageUrl: "/images/microsoft.webp",
    categories: ["Microsoft"],
  },
  {
    originalName: "microsoftmigrationwo.html",
    displayName: "MIGRATION WORKSHOP",
    imageUrl: "/images/microsoft.webp",
    categories: ["Microsoft"],
  },
  {
    originalName: "microsoftmigrationwork.html",
    displayName: "MICROSOFT SAP WORKLOADS",
    imageUrl: "/images/microsoft.webp",
    categories: ["Microsoft"],
  },
  {
    originalName: "microsoftsecengineer.html",
    displayName: "SECURITY ENGINEER",
    imageUrl: "/images/microsoft.webp",
    categories: ["Microsoft"],
  },
  {
    originalName: "microsoftshap.html",
    displayName: "MICROSOFT SHAREPOINT",
    imageUrl: "/images/microsoft.webp",
    categories: ["Microsoft"],
  },
  {
    originalName: "microsoftsolart.html",
    displayName: "MICROSOFT SOLAR TRAINING",
    imageUrl: "/images/microsoft.webp",
    categories: ["Microsoft"],
  },
  {
    originalName: "microsoftsqlserver.html",
    displayName: "SQL SERVER",
    imageUrl: "/images/microsoft.webp",
    categories: ["Microsoft"],
  },
  {
    originalName: "microsoftvs.html",
    displayName: "MICROSOFT VISUAL STUDIO",
    imageUrl: "/images/microsoft.webp",
    categories: ["Microsoft"],
  },
  {
    originalName: "microsoftdevasso.html",
    displayName: "DEVELOPMENT ASSOCIATE",
    imageUrl: "/images/microsoft.webp",
    categories: ["Microsoft"],
  },
  {
    originalName: "mictset.html",
    displayName: " COURSES",
    imageUrl: "/images/mict2.webp",
    categories: ["MICT SETA"],
  },
  {
    originalName: "softskillsbusinesscourses.html",
    displayName: "BUSINESS COURSES",
    imageUrl: "/images/soft skills.webp",
    categories: ["Soft Skills"],
  },
  {
    originalName: "softskillsinterpcourses.html",
    displayName: "INTERPERSONAL COURSES",
    imageUrl: "/images/soft skills.webp",
    categories: ["Soft Skills"],
  },
  {
    originalName: "softskillsintrapcourses.html",
    displayName: "INTRAPERSONAL COURSES",
    imageUrl: "/images/soft skills.webp",
    categories: ["Soft Skills"],
  },
  {
    originalName: "softskillssalesourses.html",
    displayName: "SALES COURSES",
    imageUrl: "/images/soft skills.webp",
    categories: ["Soft Skills"],
  },
  {
    originalName: "softskillscustomercourses.html",
    displayName: "CUSTOMER COURSES",
    imageUrl: "/images/soft skills.webp",
    categories: ["Soft Skills"],
  },
  {
    originalName: "softskillssupercourses.html",
    displayName: "SUPERVISORY COURSES",
    imageUrl: "/images/soft skills.webp",
    categories: ["Soft Skills"],
  },
  {
    originalName: "softskillsbusiness.html",
    displayName: "SOFT SKILLS BUSINESS",
    imageUrl: "/images/soft skills.webp",
    categories: ["Soft Skills"],
  },
  {
    originalName: "softskillstfcourse.html",
    displayName: "SOFT SKILLS TF COURSES",
    imageUrl: "/images/soft skills.webp",
    categories: ["Soft Skills"],
  },
  {
    originalName: "ciscoccna.html",
    displayName: "CCNA",
    imageUrl: "/images/cisco3.webp",
    categories: ["Cisco", "Networking"],
  },
  {
    originalName: "ciscoccnp.html",
    displayName: "CCNP",
    imageUrl: "/images/cisco3.webp",
    categories: ["Cisco", "Networking"],
  },
  {
    originalName: "ciscocybersec.html",
    displayName: "CYBERSECURITY",
    imageUrl: "/images/cisco3.webp",
    categories: ["Cisco", "Cybersecurity"],
  },
  {
    originalName: "ciscodatacience.html",
    displayName: "DATA SCIENCE",
    imageUrl: "/images/cisco3.webp",
    categories: ["Cisco", "Data Science"],
  },
  {
    originalName: "ciscofirepower.html",
    displayName: "FIREPOWER",
    imageUrl: "/images/cisco3.webp",
    categories: ["Cisco", "Security"],
  },
  {
    originalName: "ciscooperatingsys.html",
    displayName: "OPERATING SYSTEMS",
    imageUrl: "/images/cisco3.webp",
    categories: ["Cisco", "Operating Systems"],
  },
  {
    originalName: "ciscoprogramming.html",
    displayName: "PROGRAMMING",
    imageUrl: "/images/cisco3.webp",
    categories: ["Cisco", "Programming"],
  },
  {
    originalName: "mictseta.html",
    displayName: "Website Development",
    imageUrl: "/images/MictSeta.webp",
    categories: ["Mict Seta", "Website Development"],
  },
  {
    originalName: "mictseta.html",
    displayName: "Infrastructure Development",
    imageUrl: "/images/MictSeta.webp",
    categories: ["Mict Seta", "Infrastructure Development"],
  },
 
  {
    originalName: "mictseta.html",
    displayName: "Application Development",
    imageUrl: "/images/MictSeta.webp",
    categories: ["Mict Seta", "Programming"],
  },
  {
    originalName: "mictseta.html",
    displayName: "System Support Development NQF Level 5",
    imageUrl: "/images/MictSeta.webp",
    categories: ["Mict Seta", "System Support"],
  },
  {
    originalName: "mictseta.html",
    displayName: "Technical Support NQF Level 4",
    imageUrl: "/images/MictSeta.webp",
    categories: ["Mict Seta", "Technical Support"],
  },
  
  {
    originalName: "mictseta.html",
    displayName: "System Development Programme NQF Level 5",
    imageUrl: "/images/MictSeta.webp",
    categories: ["Mict Seta", "System Development"],
  },
  {
    originalName: "mictseta.html",
    displayName: "End User Training",
    imageUrl: "/images/MictSeta.webp",
    categories: ["Mict Seta", "End User Training"],
  },
  {
    originalName: "ai-software-developer",
    displayName: "Occupational Certificate: Artificial Intelligence Software Developer",
    imageUrl: "/images/qcto-ai-developer.png",
    categories: ["QCTO", "Artificial Intelligence"],
  },
  {
    originalName: "cybersecurity-analyst",
    displayName: "Occupational Certificate: Cybersecurity Analyst",
    imageUrl: "/images/qcto-cybersecurity.png",
    categories: ["QCTO", "Cybersecurity"],
  },
  {
    originalName: "data-science-practitioner",
    displayName: "Occupational Certificate: Data Science Practitioner",
    imageUrl: "/images/qcto-data-science.png",
    categories: ["QCTO", "Data Science"],
  },
  {
    originalName: "cloud-administrator",
    displayName: "Occupational Certificate: Cloud Administrator",
    imageUrl: "/images/qcto-cloud-admin.png",
    categories: ["QCTO", "Cloud"],
  },
  {
    originalName: "computer-technician",
    displayName: "Occupational Certificate: Computer Technician",
    imageUrl: "/images/qcto-computer-tech.png",
    categories: ["QCTO"],
  },
  {
    originalName: "software-engineer",
    displayName: "Occupational Certificate: Software Engineer",
    imageUrl: "/images/qcto-software-engineer.png",
    categories: ["QCTO", "Software Development"],
  },
];
